import { GithubOutlined } from "@/icons"
import { TicketingSystemLogo } from "@/molecules/TicketingSystemLogo"
import { UNKNOWN_TICKET_SYSTEMS } from "./ActionCard.constants"

import styles from "./Action.module.scss"

import type { ActionLabelProps } from "."

export const ActionLabel = (props: ActionLabelProps) => {
  const { hasTicketAction, hasPullRequestAction } = props
  const { ticketSystems = UNKNOWN_TICKET_SYSTEMS } = props

  if (!hasTicketAction && !hasPullRequestAction) return null

  return (
    <div className={styles.actionLabel}>
      {hasPullRequestAction && <GithubOutlined className={styles.icon} />}
      {hasTicketAction &&
        ticketSystems.map((system) => (
          <TicketingSystemLogo
            key={system}
            system={system}
            className={styles.icon}
          />
        ))}
    </div>
  )
}
